import { BaseResponseHttp } from './../http/commons.model';
import { NumberCons, StringConst } from 'src/app/constants/const';

export class OpenOrdersReport {
  transactionId: string;
  status: string;
  transactionDate: Date;
  cardCode: string;
  clientName: string;
  totalAmount: number;
  paymentDate: Date;

  constructor() {
    this.transactionId = StringConst.empty;
    this.status = StringConst.empty;
    this.transactionDate = new Date();
    this.cardCode = StringConst.empty;
    this.clientName = StringConst.empty;
    this.totalAmount = NumberCons.zero;
    this.paymentDate = new Date();
  }
}

export interface OpenOrdersReportResponse extends BaseResponseHttp {
  response: OpenOrdersReport[];
}

